'use client';

import { openCookieSettings } from './marketing-consent';

/**
 * Cookie Settings (see CONTEXT.md): reopens the cookie banner. The layout
 * guarantees one on every page of a site with Marketing Tags, in its footer
 * or, with no footer, in a strip of its own.
 */
export const CookieSettingsButton: React.FC<{ className?: string }> = ({ className }) => (
  <button
    type="button"
    className={className}
    onClick={(event) => {
      // Safari and Firefox on macOS don't focus a clicked button; the banner
      // hands focus back to whatever had it when it opened.
      event.currentTarget.focus();
      openCookieSettings();
    }}
  >
    Cookie settings
  </button>
);
